export const timelines = (state = {}, action) => {
  switch (action.type) {
    case 'SELECT_TIMELINE': {
      return {
        ...state,
        [action.payload.key]: action.payload,
      };
    }
    case 'DESELECT_TIMELINE': {
      const newState = { ...state };
      delete newState[action.payload.key];
      return newState;
    }
    default:
      return state;
  }
};
